import { reportError } from '@pypestream/utils';

/**
 * Reports a failure inside a callback ACTOR.
 *
 * `userAuthObserver` is `invoke: { src: () => (sendEvent) => ... }`, not a
 * `createInvokablePromise`, so the reporter wired into that helper never sees
 * it — and neither does a symbol sweep for the helper, which is how this
 * entrance stayed unnoticed. What fails here is the subscription that tells the
 * app its session ended: losing it leaves `watchSessionVisibility` as the only
 * remaining detector, silently.
 *
 * Guarded, like every reporter in these machines: the recovery beside it
 * (`sessionService.revalidate()`) matters more than the telemetry.
 *
 * Also used by the app-wide publish subscriptions (`useSolutionDeployments`,
 * `usePublishStatusWatcherForCoworkers`), which sit outside any invoke for the same
 * reason and used to drop their errors silently (PSTUDIO-4333).
 */
export const reportObserverFailure = (error: unknown, source: string): void => {
  try {
    reportError(error, { source, tags: { app: 'pro-studio' } });
  } catch {
    // Deliberately empty — see above.
  }
};
